var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"func-62"}},[(_vm.canal)?_c('div',{staticClass:"header"},[_c('FuncionalidadeHeader',{attrs:{"titulo":"Descredenciados","voltar":!_vm.isWidget && _vm.canal !== 'appEmbed'}})],1):_vm._e(),_c('div',{staticClass:"content"},[_c('RedeDescredenciada')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }